import React from 'react'
import { useRouteError } from "react-router-dom"
import PageMain from './PageHelpers/PageMain';
import PageFooter from './PageHelpers/PageFooter';
import PageHeaderError from './PageHelpers/PageHeaderError';


const DisplayErrorMessage = ({error}) => (
    <p>{error.statusText || error.message}</p>
)

export default function PageError() {
    const error = useRouteError();
    console.error(error);

    return (
        <div className="jm-page jm-page-error">
            <PageMain
                className="jm-ready"
                header={<PageHeaderError />}
                children={<DisplayErrorMessage error={error} />}
                footer={<PageFooter />}
            />
        </div>
    )
}